import ShPopConfirm from "@/components/Helpers/ShPopConfirm";
import ShIconWithDescription from "@/components/Helpers/ShIconWithDescription";
import RecordActionButtons from "./../RecordActionButtons";
import ParsedDayScheduleCalendar from "@/components/Common/ParsedDayScheduleCalendar";
import { DAYS_OBJECT } from "@/utils/consts";
import moment from "moment";

const today = new Date();

const year = today.getFullYear();
const month = today.getMonth();
const day = today.getDate();

const splitTime = time => time.split(":");

// @vue/component
export default {
  name: "CampaignRecordsListItem",

  components: {
    ShPopConfirm,
    ShIconWithDescription,
    RecordActionButtons,
    ParsedDayScheduleCalendar
  },

  props: {
    dictionary: {
      type: Object,
      default: () => ({})
    },
    typeList: {
      type: Array,
      default: () => []
    },
    item: {
      type: Object,
      default: () => ({})
    },
    campaignUuid: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      form: {
        isCopyNote: false,
        isDateChange: false,
        date: ""
      },
      isClonePopoverVisible: false,
      isNoteEditVisible: false,
      isEditDaysVisible: false,
      callNote: "",
      days: this.item.workday.split("").map(el => Number(el)),
      time: [
        new Date(
          year,
          month,
          day,
          splitTime(this.item.time_start)[0],
          splitTime(this.item.time_start)[1]
        ),
        new Date(
          year,
          month,
          day,
          splitTime(this.item.time_stop)[0],
          splitTime(this.item.time_stop)[1]
        )
      ]
    };
  },

  computed: {
    status() {
      if (this.dictionary.status_dictionary) {
        return this.dictionary.status_dictionary.filter(item => item.stat === this.item.result)[0];
      }
    },
    recordDictionary() {
      if (this.dictionary.record_dictionary) {
        return this.dictionary.record_dictionary.filter(
          item => item.id === this.item.dialout_dictionary_id
        )[0];
      }
    },
    isLoading() {
      return this.$store.getters["global/pendingAsyncStoreActions"].includes([
        "sms/removeSmsFromQueue"
      ]);
    },
    daysOptions() {
      return DAYS_OBJECT;
    }
  },
  methods: {
    async editNoteTimeAndDate() {
      const timesEdited = this.time.map(el => moment(el).format("HH:mm:ss"));
      const daysEdited = this.days?.sort().join("");

      const responseStatus = await this.$store.dispatch("campaign/editNoteForCall", {
        note: this.item.note,
        record_uuid: this.item.uuid,
        work_days: daysEdited,
        time_start: timesEdited[0],
        time_stop: timesEdited[1]
      });
      if (responseStatus === 200) {
        this.$message({
          type: "success",
          message: "Zapisano zmiany."
        });
        await this.$store.dispatch("campaign/getDetails", this.campaignUuid);
      } else {
        this.$message({
          type: "error",
          message: "Wystąpił błąd podczas edycji notatki"
        });
      }
      this.isEditDaysVisible = false;
    }
  }
};
